const data = {
  v: "5.5.8",
  fr: 60,
  ip: 0,
  op: 52,
  w: 24,
  h: 24,
  nm: "night-toggle",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "l6",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 11,
              s: [100],
            },
            { t: 18, s: [0] },
          ],
        },
        r: { a: 0, k: 300 },
        p: { a: 0, k: [12, 12, 0] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0, -6.004],
                    [0, -10.941],
                  ],
                  c: false,
                },
              },
              nm: "Path 1",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 2 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              d: [
                { n: "d", nm: "dash", cl: "paintable", v: { a: 0, k: 10 } },
                { n: "g", nm: "gap", v: { a: 0, k: 10 } },
                {
                  n: "o",
                  nm: "offset",
                  v: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.431], y: [1] },
                        o: { x: [0.45], y: [0] },
                        t: 0,
                        s: [0],
                      },
                      { t: 20, s: [-5] },
                    ],
                  },
                },
              ],
              cl: "paintable",
              nm: "Stroke 1",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: "Transform",
            },
          ],
          nm: "Shape 1",
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 52,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "l5",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 11,
              s: [100],
            },
            { t: 18, s: [0] },
          ],
        },
        r: { a: 0, k: 240 },
        p: { a: 0, k: [12, 12, 0] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0, -6.004],
                    [0, -10.941],
                  ],
                  c: false,
                },
              },
              nm: "Path 1",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 2 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              d: [
                { n: "d", nm: "dash", cl: "paintable", v: { a: 0, k: 10 } },
                { n: "g", nm: "gap", v: { a: 0, k: 10 } },
                {
                  n: "o",
                  nm: "offset",
                  v: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.431], y: [1] },
                        o: { x: [0.45], y: [0] },
                        t: 0,
                        s: [0],
                      },
                      { t: 20, s: [-5] },
                    ],
                  },
                },
              ],
              cl: "paintable",
              nm: "Stroke 1",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: "Transform",
            },
          ],
          nm: "Shape 1",
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 52,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "l4",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 11,
              s: [100],
            },
            { t: 18, s: [0] },
          ],
        },
        r: { a: 0, k: 180 },
        p: { a: 0, k: [12, 12, 0] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0, -6.004],
                    [0, -10.941],
                  ],
                  c: false,
                },
              },
              nm: "Path 1",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 2 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              d: [
                { n: "d", nm: "dash", cl: "paintable", v: { a: 0, k: 10 } },
                { n: "g", nm: "gap", v: { a: 0, k: 10 } },
                {
                  n: "o",
                  nm: "offset",
                  v: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.431], y: [1] },
                        o: { x: [0.45], y: [0] },
                        t: 0,
                        s: [0],
                      },
                      { t: 20, s: [-5] },
                    ],
                  },
                },
              ],
              cl: "paintable",
              nm: "Stroke 1",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: "Transform",
            },
          ],
          nm: "Shape 1",
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 52,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "l3",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 11,
              s: [100],
            },
            { t: 18, s: [0] },
          ],
        },
        r: { a: 0, k: 120 },
        p: { a: 0, k: [12, 12, 0] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0, -6.004],
                    [0, -10.941],
                  ],
                  c: false,
                },
              },
              nm: "Path 1",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 2 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              d: [
                { n: "d", nm: "dash", cl: "paintable", v: { a: 0, k: 10 } },
                { n: "g", nm: "gap", v: { a: 0, k: 10 } },
                {
                  n: "o",
                  nm: "offset",
                  v: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.431], y: [1] },
                        o: { x: [0.45], y: [0] },
                        t: 0,
                        s: [0],
                      },
                      { t: 20, s: [-5] },
                    ],
                  },
                },
              ],
              cl: "paintable",
              nm: "Stroke 1",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: "Transform",
            },
          ],
          nm: "Shape 1",
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 52,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "l2",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 11,
              s: [100],
            },
            { t: 18, s: [0] },
          ],
        },
        r: { a: 0, k: 60 },
        p: { a: 0, k: [12, 12, 0] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0, -6.004],
                    [0, -10.941],
                  ],
                  c: false,
                },
              },
              nm: "Path 1",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 2 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              d: [
                { n: "d", nm: "dash", cl: "paintable", v: { a: 0, k: 10 } },
                { n: "g", nm: "gap", v: { a: 0, k: 10 } },
                {
                  n: "o",
                  nm: "offset",
                  v: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.431], y: [1] },
                        o: { x: [0.45], y: [0] },
                        t: 0,
                        s: [0],
                      },
                      { t: 20, s: [-5] },
                    ],
                  },
                },
              ],
              nm: "Stroke 1",
              cl: "paintable",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: "Transform",
            },
          ],
          nm: "Shape 1",
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 52,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: "l1",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 11,
              s: [100],
            },
            { t: 18, s: [0] },
          ],
        },
        p: { a: 0, k: [12, 12, 0] },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0, -6.004],
                    [0, -10.941],
                  ],
                  c: false,
                },
              },
              nm: "Path 1",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 2 },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              d: [
                { n: "d", nm: "dash", v: { a: 0, k: 10 } },
                { n: "g", nm: "gap", v: { a: 0, k: 10 } },
                {
                  n: "o",
                  nm: "offset",
                  v: {
                    a: 1,
                    k: [
                      {
                        i: { x: [0.431], y: [1] },
                        o: { x: [0.45], y: [0] },
                        t: 0,
                        s: [0],
                      },
                      { t: 20, s: [-5] },
                    ],
                  },
                },
              ],
              nm: "Stroke 1",
              cl: "paintable",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: "Transform",
            },
          ],
          nm: "Shape 1",
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 52,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "c",
      sr: 1,
      ks: { p: { a: 0, k: [12, 12, 0] }, a: { a: 0, k: [-1.237, -2.112, 0] } },
      ao: 0,
      hasMask: true,
      masksProperties: [
        {
          inv: false,
          mode: "s",
          pt: {
            a: 1,
            k: [
              {
                i: { x: 0, y: 1 },
                o: { x: 0.333, y: 0 },
                t: 25,
                s: [
                  {
                    i: [
                      [3.55, 0],
                      [0, -3.55],
                      [-3.55, 0],
                      [0, 3.55],
                    ],
                    o: [
                      [-3.55, 0],
                      [0, 3.55],
                      [3.55, 0],
                      [0, -3.55],
                    ],
                    v: [
                      [9.94, -19.487],
                      [3.513, -13.06],
                      [9.94, -6.633],
                      [16.367, -13.06],
                    ],
                    c: true,
                  },
                ],
              },
              {
                t: 52,
                s: [
                  {
                    i: [
                      [3.55, 0],
                      [0, -3.55],
                      [-3.55, 0],
                      [0, 3.55],
                    ],
                    o: [
                      [-3.55, 0],
                      [0, 3.55],
                      [3.55, 0],
                      [0, -3.55],
                    ],
                    v: [
                      [3.065, -12.362],
                      [-3.362, -5.935],
                      [3.065, 0.492],
                      [9.492, -5.935],
                    ],
                    c: true,
                  },
                ],
              },
            ],
          },
          o: { a: 0, k: 100 },
          x: { a: 0, k: 0 },
          nm: "Mask 1",
        },
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.396, 0.396], y: [0, 0] },
                    t: 16,
                    s: [6, 6],
                  },
                  { t: 41, s: [16, 16] },
                ],
              },
              p: { a: 0, k: [0, 0] },
              cl: "paintable",
              nm: "Ellipse Path 1",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              cl:"paintable",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [-1.237, -2.112] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: "Transform",
            },
          ],
          nm: "Ellipse 1", 
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 52,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};

export default data;
